import { render, staticRenderFns } from "./TouchIconButton.vue?vue&type=template&id=9a3955c0&scoped=true"
import script from "./TouchIconButton.vue?vue&type=script&lang=js"
export * from "./TouchIconButton.vue?vue&type=script&lang=js"
import style0 from "./TouchIconButton.vue?vue&type=style&index=0&id=9a3955c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a3955c0",
  null
  
)

export default component.exports